import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as FullStar} from '@fortawesome/free-solid-svg-icons';
import { faStar as EmptyStar} from '@fortawesome/free-regular-svg-icons';
import styles from '../../styles/review/ReviewScore.module.scss';

const Star = (props) => {
    const {score, isEditable, setScore, order } = props;

    const handleSetScore = () => {
        if (isEditable) {
            setScore(order)
        }
    }

    return (
            <FontAwesomeIcon width="32" height="32" size="2x"  icon={ order<=score ? FullStar : EmptyStar} onClick={handleSetScore}
                className={ styles[`star${score}`]}/>
    );
}

export default Star;